const cssReset = `
  * {
    box-sizing: border-box; /* Ensures padding and border are included in the total width and height of elements */
  }

  html, body {
    position: relative;
    margin: 0;
    padding: 0;
    line-height: 1.6;
    font-family: Arial, sans-serif; /* Fallback font family */
    min-height: 100vh;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }

  a {
    color: inherit; /* Inherit color from parent element */
    text-decoration: none; /* Remove underline */
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
  }
`;

const hartfordNavLayout = `
<div>
  <div class="hartford-nav">
    <div class="hartford-nav-content">
      <div class="partner-text">Best partner for The Hartford</div>
      <h1 class="page-title">{{ currentPage.DisplayName }}</h1>
      <div class="navigation-bar">
        <ul>
          {{#each Pages}}
            <li><a href="{{ ../basePath }}/{{ this.Slug }}">{{ this.DisplayName }}</a></li>
          {{/each}}
        </ul>
      </div>
    </div>
  </div>

  {{> @partial-block }}

  {{> hartford/Footer logoUrl=logoUrl }}
</div>
`;

const hartfordNavLayoutStyles = `
${cssReset}

.hartford-nav {
  height: 400px;
  background-color: #3a5a78;
  color: white;
  display: flex;
  flex-direction: column;
  position: relative;
}

.hartford-nav-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 30px;
  box-sizing: border-box;
}

.partner-text {
  font-size: 18px;
  margin-bottom: 20px;
}

.page-title {
  font-size: 72px;
  font-weight: bold;
  margin: 0;
  margin-top: 60px;
  flex-grow: 1;
}

.navigation-bar {
  margin-top: auto;
}

.navigation-bar ul {
  list-style: none;
  display: flex;
  gap: 20px;
  padding: 0;
  margin: 0;
}

.navigation-bar li {
  display: inline-block;
}

.navigation-bar a {
  color: white;
  text-decoration: none;
  font-size: 16px;
  transition: opacity 0.2s ease;
}

.navigation-bar a:hover {
  opacity: 0.8;
}
`;

const hartfordFooter = `
<footer class="hartford-footer">
  <div class="footer-divider">
    <div class="divider-line"></div>
    <div class="divider-logo">
      <img src="{{ logoUrl }}" alt="Optum Logo" />
    </div>
    <div class="divider-line"></div>
  </div>
  <button class="back-to-top" onclick="window.scrollTo({top: 0, behavior: 'smooth'})">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
    Back to top
  </button>
  <div class="copyright">
    © ${new Date().getFullYear()} Optum, Inc. All rights reserved. Stock photos used.
  </div>
</footer>
`;

const hartfordFooterStyles = `
.hartford-footer {
  padding: 60px 30px 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f8f9fa;
}

.footer-divider {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 30px;
}

.divider-line {
  flex: 1;
  height: 1px;
  background-color: #ddd;
}

.divider-logo {
  padding: 0 30px;
}

.divider-logo img {
  height: 40px;
  width: auto;
}

.back-to-top {
  display: flex;
  align-items: center;
  background-color: #0066cc;
  color: white;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 25px;
  transition: background-color 0.3s ease, transform 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.back-to-top svg {
  margin-right: 8px;
}

.back-to-top:hover {
  background-color: #004d99;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.copyright {
  font-size: 14px;
  color: #666;
  text-align: center;
}

@media (max-width: 768px) {
  .footer-divider {
    flex-direction: column;
  }

  .divider-line {
    width: 80%;
    margin: 15px 0;
  }

  .divider-logo {
    padding: 15px 0;
  }
}
`;

export const commonBlocks: any[] = [
  {
    name: 'hartford/NavLayout',
    partial: hartfordNavLayout,
    css: hartfordNavLayoutStyles,
  },
  {
    name: 'hartford/Footer',
    partial: hartfordFooter,
    css: hartfordFooterStyles,
  },
];
